module.exports = __webpack_public_path__ + "static/media/[擦汗]@2x.5aaefc42.png";